// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './index.css'; // Importation du CSS principal avec Tailwind/DaisyUI
import AppRoutes from './AppRoutes';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    //<React.StrictMode>
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    // </React.StrictMode>
);

reportWebVitals();
